import { render, staticRenderFns } from "./FieldLanguages.vue?vue&type=template&id=2de15612"
import script from "./FieldLanguages.vue?vue&type=script&lang=js"
export * from "./FieldLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports